// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/" + chunkId + "." + {"209": "7c01262a","398": "90302633","409": "a69e28b8","545": "c9da46ad","868": "07278252","925": "f6592ff4",}[chunkId] + ".chunk.js"
}